/**
 * Options API mixin for the "Account & People" pages.
 *
 * The implementation lives in `account-admin.js` — new pages should import that
 * module directly. This mixin remains as the callback-style wrapper the older
 * Options API pages (and PrimaryLayout) use.
 */

import globalStore from "/globalStore.js";
import { resolveAccountAdminAccountId, getAccount } from "/account-admin/account-admin.js";

var accountAdminMixin = {




	data()
	{
		return {
			globalStore: globalStore,

			account: {
				id: "",
				name: "",
				status: "",
				defaultTimezoneID: "",
				defaultTimezoneCurrentOffset: ""
			}
		};
	},







	methods: {


		/**
		 * Calculate and return the account ID to use for the current account-admin page.
		 */
		getCurrentAccountAdminAccountId()
		{
			return resolveAccountAdminAccountId(this.$route);
		},



		async loadAccount(callback)
		{
			const account = await getAccount(this.getCurrentAccountAdminAccountId());

			if (account == null)
			{
				if (callback) callback(false);
				return; // Not successful
			}

			this.account = account;

			if (callback) callback(true);
		},

	}

};

export default accountAdminMixin;
